import type { Language } from '../../i18n/translations.js';
import { DEMO_COPY } from './demo-copy.js';
export function BusinessProfileStage({
  language,
  step,
  go,
}: {
  readonly language: Language;
  readonly step: number;
  readonly go: (next: number) => void;
}) {
  const c = DEMO_COPY[language];
  return (
    <section
      className="stage mw-stage mw-profile-stage"
      id="stage-1"
      aria-labelledby="profile-title"
      hidden={step !== 1}
    >
      <div className="mw-stage-heading">
        <h3 id="profile-title" tabIndex={-1}>
          {c.yourBusinessUnderstood}
        </h3>
      </div>
      <div className="mw-profile-card">
        <div className="mw-profile-identity">
          <div className="mw-business-avatar">
            {'N'}
            <span aria-hidden="true">{'.'}</span>
          </div>
          <div>
            <strong>{'Nurtelia'}</strong>
            <span dir="ltr">{'nurtelia.example'}</span>
          </div>
          <span className="mw-small-tag">{c.sampleProfile}</span>
        </div>
        <dl className="mw-profile-facts">
          <div>
            <dt>{c.business2}</dt>
            <dd>{c.packagedCookies}</dd>
          </div>
          <div>
            <dt>{c.style}</dt>
            <dd>{c.playfulUnexpected}</dd>
          </div>
          <div>
            <dt>{c.videoIdea}</dt>
            <dd>{c.anUnexpectedProductReveal}</dd>
          </div>
        </dl>
      </div>
      <div className="mw-next-row">
        <button
          className="btn mw-target"
          id="use-profile"
          type="button"
          onClick={() => {
            go(2);
          }}
        >
          <span className="cs-px3" aria-hidden="true">
            <i></i>
            <i></i>
            <i></i>
          </span>
          <span>{c.chooseAVideo}</span>
        </button>
      </div>
    </section>
  );
}
